import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Navbar2, Footer2 } from "../../components";
import SeriesNav from "../../components/labs/SeriesNav";
import { getRouteMeta } from "../../seoData";

function DigitalForensicsHomelab() {
  const { title, description: desc, image, url } = getRouteMeta(
    "/digital-forensics-homelab"
  );

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} data-react-helmet="true"></meta>

        <meta property="og:type" content="website" data-react-helmet="true"></meta>
        <meta property="og:url" content={url} data-react-helmet="true"></meta>
        <meta property="og:title" content={title} data-react-helmet="true"></meta>
        <meta property="og:description" content={desc} data-react-helmet="true"></meta>
        <meta property="og:image" content={image} data-react-helmet="true"></meta>

        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:url" content={url} data-react-helmet="true"></meta>
        <meta property="twitter:title" content={title} data-react-helmet="true"></meta>
        <meta property="twitter:description" content={desc} data-react-helmet="true"></meta>
        <meta property="twitter:image" content={image} data-react-helmet="true"></meta>
      </Helmet>
      <Navbar2 />
      <section id="blogs">
        <div className="blogs main">
          <div className="blogs-header pb-4">
            <Link to="/projects/" className="blog-back-link">
              <i className="fa-solid fa-arrow-left"></i>&nbsp;Back to Projects
            </Link>
            <h2 className="section-title">Digital Forensics HomeLab</h2>
            <div className="blog-meta">
              <span>
                <i className="fa-solid fa-flask"></i>Part 1: Introduction ·
                Work In Progress
              </span>
            </div>
          </div>

          <SeriesNav current="/digital-forensics-homelab/" />

          <p className="m-5">
            I'm building a self-hosted lab environment to practice digital
            forensics and incident response outside of a production network.
            The current topology is centered on Active Directory: a domain
            controller and domain-joined clients generating real Windows/AD
            artifacts (logons, group policy activity, process and network
            traces) that I can then acquire and analyze the way I would on
            an actual case. That's the starting point, not the whole plan.
            I'm looking to add a Linux machine and a Wazuh server for
            detection and monitoring down the line.
          </p>

          <p className="m-5">
            The lab is a work in progress, and it's going to stay that way
            as I keep expanding it. I haven't run any exercises against the
            AD environment yet. This page will get updated with write-ups
            and new additions as that work happens.
          </p>

          <div>
            <div>
              <p className="fw-bolder">The setup so far:</p>
              <ol>
                <li className="m-2">
                  <span className="fw-bolder">Host &amp; hypervisor:</span> an
                  Ubuntu host running virt-manager (libvirt/KVM) for all
                  virtual machines.
                </li>
                <li className="m-2">
                  <span className="fw-bolder">Network:</span> a pfSense VM
                  acting as the firewall/router, segmenting the lab network
                  from the rest of my home network.
                </li>
                <li className="m-2">
                  <span className="fw-bolder">Domain controller:</span> a
                  Windows Server 2022 VM running Active Directory Domain
                  Services and acting as the domain's primary DNS.
                </li>
                <li className="m-2">
                  <span className="fw-bolder">Domain-joined clients:</span>{" "}
                  two Windows 11 machines joined to the domain, each pulling a
                  logon script pushed from the DC on sign-in.
                </li>
                <li className="m-2">
                  <span className="fw-bolder">Kali Linux:</span> for
                  offensive tooling and simulating attacker activity,
                  deliberately kept off the domain and not connected to the
                  DC.
                </li>
                <li className="m-2">
                  <span className="fw-bolder">CAINE (live boot):</span> for
                  forensic acquisition and analysis of the artifacts I
                  generate, also kept off the domain and not connected to the
                  DC.
                </li>
              </ol>
            </div>

            <p className="m-5">
              <span className="fw-bolder">Up next:</span> Part 2 walks
              through how everything above is actually wired together, the
              network topology, and how DNS falls back to pfSense if the DC
              ever goes offline.
            </p>
          </div>

          <SeriesNav current="/digital-forensics-homelab/" />
        </div>
        <Footer2 />
      </section>
    </div>
  );
}

export default DigitalForensicsHomelab;
